module.exports = __webpack_public_path__ + "static/media/taiwan-intersection.65ecd158.jpg";